/* URA product interactions, 18 Sep 2026.
   Progressive presentation only: existing navigation nodes and handlers remain.
   No product data, photographs, cart requests or gallery sequence are changed. */
(()=>{
  'use strict';
  if(window.__uraProductInteractions0918)return;
  window.__uraProductInteractions0918=true;
  const fine=matchMedia('(hover:hover) and (pointer:fine)');
  const reduce=matchMedia('(prefers-reduced-motion:reduce)');
  const contrast=matchMedia('(forced-colors:active)');
  const language=(document.documentElement.lang||'en').slice(0,2);
  const groupLabel=language==='ar'?'التنقّل بين الصور':language==='es'?'Navegar por las imágenes':'Image navigation';
  const clamp=(v,a,b)=>Math.min(Math.max(a,b),Math.max(a,v));
  const configurations=[
    ['[data-card-controls]','[data-card-previous]','[data-card-next]','card'],
    ['.ura4-gallery__arrows','[data-ura4-gallery-prev]','[data-ura4-gallery-next]','gallery'],
    ['.ura4-lightbox__nav','[data-ura4-lightbox-prev]','[data-ura4-lightbox-next]','lightbox'],
    ['[data-uac-controls]','[data-uac-prev]','[data-uac-next]','arrival']
  ];
  let scanFrame=0,paintFrame=0,lastPointer=null,currentTarget=null,blockedTarget=null;
  let lens=null,lensTimer=0,lensSource=null;
  const highResolution=new Map();

  function arrow(button,direction){
    const icon=button.querySelector('svg');
    if(!icon)return; // Keep the existing text arrows and their accessible labels.
    icon.setAttribute('viewBox','0 0 24 24');
    icon.setAttribute('aria-hidden','true');
    const path=document.createElementNS('http://www.w3.org/2000/svg','path');
    path.setAttribute('d',direction==='previous'?'M19 12H5m6-6-6 6 6 6':'M5 12h14m-6-6 6 6-6 6');
    icon.replaceChildren(path);
  }
  function pair(host,previousSelector,nextSelector,kind){
    if(host.hasAttribute('data-ura-swap-host'))return;
    const previous=host.querySelector(previousSelector),next=host.querySelector(nextSelector);
    if(!previous||!next||previous.parentElement!==next.parentElement)return;
    const group=document.createElement('span');
    group.className='ura-swap-pair';group.dir='ltr';
    group.setAttribute('role','group');group.setAttribute('aria-label',groupLabel);
    previous.before(group);group.append(previous,next);
    [[previous,'previous'],[next,'next']].forEach(([button,direction])=>{
      button.dataset.uraSwapButton=direction;
      if(!button.hasAttribute('data-ura-magnetic'))button.dataset.uraMagnetic='icon';
      arrow(button,direction);
    });
    host.dataset.uraSwapHost=kind;
    if(kind==='card'){
      const progress=host.closest('[data-card-viewer]')?.querySelector('.ucv__progress');
      if(progress)host.prepend(progress);
    }
    // Gallery navigation remains in its authored image stage so previous/next
    // can live at the visual midpoint on desktop, laptop and touch layouts.
  }
  function scan(){
    scanFrame=0;
    configurations.forEach(([selector,previous,next,kind])=>{
      document.querySelectorAll(selector).forEach(host=>pair(host,previous,next,kind));
    });
  }
  function available(){return fine.matches&&!reduce.matches&&!contrast.matches&&!document.hidden;}
  function overlayOpen(){return Boolean(document.querySelector('dialog[open],#ura-index.is-open,#ura-mega-menu.is-open,[data-ura-cart-drawer].is-open,[data-ura2-filter-room]:not([hidden])'));}
  function hide(){
    clearTimeout(lensTimer);lensTimer=0;lensSource=null;currentTarget=null;
    if(lens)lens.hidden=true;
  }
  function dismiss(){blockedTarget=currentTarget;hide();}
  function imageGeometry(image){
    if(!image?.complete||!image.naturalWidth||!image.naturalHeight)return null;
    const r=image.getBoundingClientRect();
    if(r.width<=0||r.height<=0)return null;
    // The existing gallery uses object-fit:contain with a centered position.
    const scale=Math.min(r.width/image.naturalWidth,r.height/image.naturalHeight);
    const width=image.naturalWidth*scale,height=image.naturalHeight*scale;
    return{left:r.left+(r.width-width)/2,top:r.top+(r.height-height)/2,width,height};
  }
  function inside(point,box){return point.x>=box.left&&point.x<=box.left+box.width&&point.y>=box.top&&point.y<=box.top+box.height;}
  function getLens(){
    if(lens)return lens;
    lens=document.createElement('div');lens.id='UraProductLens0918';lens.className='ura-product-lens';
    lens.setAttribute('aria-hidden','true');lens.hidden=true;
    document.body.append(lens);return lens;
  }
  function requestDetail(button){
    const src=button.getAttribute('data-full-src');
    if(!src)return;
    lensTimer=setTimeout(()=>{
      lensTimer=0;
      if(currentTarget!==button||!available()||overlayOpen())return;
      const reveal=photo=>{
        if(currentTarget!==button||blockedTarget===button||!available()||overlayOpen())return;
        lensSource=photo;queuePaint();
      };
      let photo=highResolution.get(src);
      if(photo?.complete&&photo.naturalWidth){reveal(photo);return;}
      photo=new Image();photo.decoding='async';
      photo.onload=()=>{highResolution.set(src,photo);if(highResolution.size>6)highResolution.delete(highResolution.keys().next().value);reveal(photo);};
      photo.onerror=()=>{if(currentTarget===button){lensSource=null;if(lens)lens.hidden=true;}};
      photo.src=src;
    },280);
  }
  function paint(){
    paintFrame=0;
    if(!lastPointer||!available()||overlayOpen()){hide();return;}
    const {target,x,y}=lastPointer;
    if(!(target instanceof Element)||!target.isConnected){hide();return;}
    const button=target.closest('[data-ura4-lightbox-open]');
    const active=button;
    if(blockedTarget&&active!==blockedTarget)blockedTarget=null;
    if(!active||active===blockedTarget||active.closest('[hidden],[inert],[aria-hidden="true"]')){hide();return;}
    if(active!==currentTarget){hide();currentTarget=active;requestDetail(button);}
    const vw=document.documentElement.clientWidth,vh=window.innerHeight;
    const image=button.querySelector('img');const box=imageGeometry(image);
    if(!box||!inside({x,y},box)||!lensSource){if(lens)lens.hidden=true;return;}
    const magnification=Math.min(2,lensSource.naturalWidth/box.width,lensSource.naturalHeight/box.height);
    if(magnification<=1.05){if(lens)lens.hidden=true;return;}
    const view=getLens();
    const diameter=clamp(Math.min(box.width,box.height)*.34,124,176);
    view.style.width=diameter+'px';view.style.height=diameter+'px';
    view.style.left=clamp(x-diameter/2,8,vw-diameter-8)+'px';
    view.style.top=clamp(y-diameter/2,8,vh-diameter-8)+'px';
    view.style.backgroundImage='url('+JSON.stringify(lensSource.src)+')';
    view.style.backgroundSize=(box.width*magnification)+'px '+(box.height*magnification)+'px';
    view.style.backgroundPosition=(diameter/2-(x-box.left)*magnification)+'px '+(diameter/2-(y-box.top)*magnification)+'px';
    view.hidden=false;
  }
  function queuePaint(){if(!paintFrame)paintFrame=requestAnimationFrame(paint);}
  document.addEventListener('pointermove',event=>{
    if(event.pointerType!=='mouse'){hide();return;}
    lastPointer={target:event.target,x:event.clientX,y:event.clientY};queuePaint();
  },{passive:true});
  document.addEventListener('pointerout',event=>{
    if(currentTarget&&!currentTarget.contains(event.relatedTarget)){
      if(blockedTarget===currentTarget)blockedTarget=null;hide();
    }
  },{passive:true});
  document.addEventListener('pointerdown',()=>{lastPointer=null;hide();},{passive:true});
  document.addEventListener('keydown',event=>{if(event.key==='Escape')dismiss();else{lastPointer=null;hide();}});
  document.addEventListener('focusin',()=>{lastPointer=null;hide();});
  document.addEventListener('scroll',()=>{lastPointer=null;hide();},{passive:true,capture:true});
  window.addEventListener('blur',()=>{lastPointer=null;hide();});
  window.addEventListener('resize',()=>{lastPointer=null;hide();},{passive:true});
  document.addEventListener('visibilitychange',()=>{lastPointer=null;hide();});
  [fine,reduce,contrast].forEach(media=>media.addEventListener('change',()=>{lastPointer=null;hide();}));
  const observer=new MutationObserver(records=>{
    if(currentTarget&&(!currentTarget.isConnected||overlayOpen()))hide();
    if(records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1))&&!scanFrame)scanFrame=requestAnimationFrame(scan);
  });
  function boot(){scan();observer.observe(document.body,{childList:true,subtree:true});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:section:unload',hide);
})();
